import '../../css/sections/TechStackMarquee.css';
import Marquee from "react-fast-marquee";
import { motion } from "framer-motion";

function TechStackMarquee() {

    return (
        <motion.div className={`marquee-container`}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0 }}
            viewport={{ once: true, amount: 0.08 }}
        >
            <Marquee play speed={350} gradientColor='var(--white)' gradient={true} gradientWidth={window.innerWidth <= 768 ? 0 : 200} className='marquee'>
                {/* <div className='marquee-item'>
                    <img src="/images/html.png" alt="HTML5 logo" />
                </div>
                <div className='marquee-item'>
                    <img src="/images/css.png" alt="CSS3 logo" />
                </div>
                <div className='marquee-item'>
                    <img src="/images/javascript.png" alt="JavaScript logo" />
                </div> */}
                <div className='marquee-item'>
                    <img src="/images/python.png" alt="Python logo" style={{ width: window.innerWidth <= 1200 ? '3.5rem' : '5rem' }} />
                </div>
                <div className='marquee-item'>
                    <img src="/images/php.png" alt="PHP logo" style={{ width: window.innerWidth <= 1200 ? '7rem' : '9rem' }} />
                </div>
                <div className='marquee-item'>
                    <img src="/images/react.svg" alt="React logo" style={{ width: window.innerWidth <= 1200 ? '8rem' : '12rem' }} />
                </div>
                <div className='marquee-item'>
                    <img src="/images/nextjs.svg" alt="Next.js logo" style={{ width: window.innerWidth <= 1200 ? '8rem' : '11rem' }} />
                </div>
                <div className='marquee-item'>
                    <img src="/images/nodejs.svg" alt="Node.js logo" style={{ width: window.innerWidth <= 1200 ? '9rem' : '13rem' }} />
                </div>
                <div className='marquee-item'>
                    <img src="/images/express.png" alt="Express.js logo" style={{ width: window.innerWidth <= 1200 ? '4rem' : '5rem' }} />
                </div>
                <div className='marquee-item'>
                    <img src="/images/mongodb.png" alt="MongoDB logo" style={{ width: window.innerWidth <= 1200 ? '12rem' : '18rem' }} />
                </div>
                <div className='marquee-item'>
                    <img src="/images/mysql.svg" alt="MySQL logo" style={{ width: window.innerWidth <= 1200 ? '8rem' : '13rem' }} />
                </div>
                <div className='marquee-item'>
                    <img src="/images/upstash.svg" alt="Upstash Redis logo" style={{ width: window.innerWidth <= 1200 ? '9rem' : '14rem' }} />
                </div>
                <div className='marquee-item'>
                    <img src="/images/tailwind.svg" alt="Tailwind CSS logo" style={{ width: window.innerWidth <= 1200 ? '14rem' : '20rem' }} />
                </div>
                <div className='marquee-item'>
                    <img src="/images/aceternity.png" alt="Aceternity UI logo" style={{ width: window.innerWidth <= 1200 ? '16rem' : '18rem' }} />
                </div>
                <div className='marquee-item'>
                    <img src="/images/motion.png" alt="Motion (Framer Motion) logo" style={{ width: window.innerWidth <= 1200 ? '4rem' : '5rem' }} />
                </div>
                <div className='marquee-item'>
                    <img src="/images/clerk.svg" alt="Clerk logo" style={{ width: window.innerWidth <= 1200 ? '8rem' : '12rem' }} />
                </div>
                <div className='marquee-item'>
                    <img src="/images/stripe.png" alt="Stripe logo" style={{ width: window.innerWidth <= 1200 ? '7rem' : '9rem' }} />
                </div>
                <div className='marquee-item'>
                    <img src="/images/resend.png" alt="Resend logo" style={{ width: window.innerWidth <= 1200 ? '8rem' : '12rem' }} />
                </div>
                <div className='marquee-item'>
                    <img src="/images/posthog.svg" alt="Posthog logo" style={{ width: window.innerWidth <= 1200 ? '9rem' : '15rem' }} />
                </div>
                <div className='marquee-item'>
                    <img src="/images/cloudflare.png" alt="Cloudflare logo" style={{ width: window.innerWidth <= 1200 ? '9rem' : '13rem' }} />
                </div>
                <div className='marquee-item'>
                    <img src="/images/docker.svg" alt="Docker logo" style={{ width: window.innerWidth <= 1200 ? '10rem' : '14rem' }} />
                </div>
                <div className='marquee-item'>
                    <img src="/images/dokploy.svg" alt="Dokploy logo" style={{ width: window.innerWidth <= 1200 ? '2rem' : '4rem' }} />
                </div>
                <div className='marquee-item'>
                    <img src="/images/vercel.png" alt="Vercel logo" style={{ width: window.innerWidth <= 1200 ? '10rem' : '13rem' }} />
                </div>
                <div className='marquee-item'>
                    <img src="/images/railway2.webp" alt="Railway logo" style={{ width: window.innerWidth <= 1200 ? '13rem' : '17rem' }} />
                </div>
                <div className='marquee-item'>
                    <img src="/images/claude.svg" alt="Claude logo" style={{ width: window.innerWidth <= 1200 ? '9rem' : '14rem' }} />
                </div>
                <div className='marquee-item'>
                    <img src="/images/openai.png" alt="OpenAI logo" style={{ width: window.innerWidth <= 1200 ? '9rem' : '13rem' }} />
                </div>
                <div className='marquee-item'>
                    <img src="/images/make.jpg" alt="Make logo" style={{ width: window.innerWidth <= 1200 ? '9rem' : '14rem' }} />
                </div>
                <div className='marquee-item'>
                    <img src="/images/loxone.png" alt="Loxone logo" style={{ width: window.innerWidth <= 1200 ? '10rem' : '17rem' }} />
                </div>
                <div className='marquee-item'>
                    <img src="/images/figma.png" alt="Figma logo" style={{ width: window.innerWidth <= 1200 ? '4rem' : '5rem' }} />
                </div>
                <div className='marquee-item'>
                    <img src="/images/photoshop.png" alt="Adobe Photoshop logo" style={{ width: window.innerWidth <= 1200 ? '4rem' : '5rem' }} />
                </div>
                <div className='marquee-item'>
                    <img src="/images/illustrator.png" alt="Adobe Illustrator logo" style={{ width: window.innerWidth <= 1200 ? '4.2rem' : '5.3rem' }} />
                </div>
                <div className='marquee-item'>
                    <img src="/images/lightroom.png" alt="Adobe Lightroom logo" style={{ width: window.innerWidth <= 1200 ? '4rem' : '5rem' }} />
                </div>
                <div className='marquee-item'>
                    <img src="/images/xd.png" alt="Adobe XD logo" style={{ width: window.innerWidth <= 1200 ? '4rem' : '5rem' }} />
                </div>
                <div className='marquee-item'>
                    <img src="/images/tinkercad.svg" alt="Tinkercad logo" style={{ width: window.innerWidth <= 1200 ? '10rem' : '14rem' }} />
                </div>
            </Marquee>
        </motion.div>
    );
}

export default TechStackMarquee;
